<template>
  <div v-if="!!(data.value instanceof Array)">
    <div v-for="(text, key) in data.value" :key="key" :qaid="`grid-text-${key}`">
      {{ text }}
    </div>
  </div>
  <div v-else>
    <div :ref="`tooltipTemplate-${data.value}`">
      <div v-if="data.tooltip" class="max-w-md w-full text-left">
        <div v-if="data.tooltip.MFR && data.tooltip.MFR != 'NULL'" class="text-xs">
          <span class="font-bold">MFR: </span>{{ data.tooltip.MFR }}
        </div>
        <div v-if="data.tooltip.replacementProductUrl" class="sm:hidden md:hidden lg:flex">
          <pdl-link xsmall qaid="grid-replacement-product-link" text :href="replacementProductUrl">
            {{ data.tooltip.replacementProductText }}
          </pdl-link>
        </div>
      </div>
    </div>

    <div class="flex" :class="{'flex-col justify-center': !showTooltip}">
      <!-- PLP and on other grids we need link on SKu to navigate to PDP-->
      <div v-if="data.link">
        <a
          :href="data.link"
          class="underline hover:no-underline"
          qaid="grid-text-link"
          :target="linkTarget"
          v-html="data.value"
        />
      </div>
      <!-- If there is no link and other columns use this -->
      <div v-else qaid="grid-text" v-html="data.value" />

      <!-- Handle the tooltip for UPC and MFR with both  -->
      <button v-if="data.tooltip && showTooltip" v-tippy="tippyConfig" type="button">
        <span class="sr-only">{{ $t('text.productInformation') }}</span>
        <pdl-icon class="b2b-grid__text__tooltip-icon text-base align-text-bottom no-underline" name="info" size="18" />
      </button>
    </div>

    <div v-if="(!data.tooltip || !showTooltip) && data.type === 'date'" class="flex items-center lg:justify-end">
      <pdl-icon v-show="data.warn === true" class="text-warning mr-25" size="18" name="warning" />
      {{ formatDate(data.value) }}
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex';
import {PdlIcon} from '@pedal/pdl-icon';
import {PdlLink} from '@pedal/pdl-link';

export default {
  name: 'GridText',
  components: {PdlIcon, PdlLink},
  props: {
    data: {
      type: Object,
      default: () => null,
    },
  },
  computed: {
    ...mapState('backend', ['encodedContextPath']),
    showTooltip() {
      return !!(this.data?.tooltip && Object.keys(this.data?.tooltip).length > 0);
    },
    replacementProductUrl() {
      return this.encodedContextPath + this.data.tooltip.replacementProductUrl;
    },
    linkTarget() {
      return this.data?.isNewTab ? '_blank' : '_self';
    },
    tippyConfig() {
      return {
        allowHTML: true,
        content: this.getTooltipTemplateElement,
        placement: 'top-start',
        arrow: true,
        interactive: true,
        onMount: this.addTooltipBlurListener,
        onHidden: this.removeTooltipBlurListener,
      };
    },
  },
  methods: {
    formatDate: function (rawDate) {
      var date = new Date(rawDate);
      var year = date.getFullYear();

      var month = (1 + date.getMonth()).toString();
      month = month.length > 1 ? month : '0' + month;

      var day = date.getDate().toString();
      day = day.length > 1 ? day : '0' + day;

      return month + '/' + day + '/' + year;
    },

    getTooltipTemplateElement() {
      return this.$refs[`tooltipTemplate-${this.data.value}`];
    },

    addTooltipBlurListener(instance) {
      const linkEl = instance.popper?.querySelector('a');
      if (linkEl) {
        instance._blurHandler = () => {
          instance.hide();
        };

        linkEl.addEventListener('blur', instance._blurHandler);
      }
    },

    removeTooltipBlurListener(instance) {
      const linkEl = instance.popper?.querySelector('a');
      if (linkEl && instance._blurHandler) {
        linkEl.removeEventListener('blur', instance._blurHandler);
        delete instance._blurHandler;
      }
    },
  },
};
</script>
